// Migrated 1:1 from @nexato/nx-core-module (shared/services/eventSubscription/eventSubscriptionService.ts) for #684
import { Injectable } from '@angular/core';
import { TimeEntryInput } from '../../entities/timeEntry/timeEntry';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';
import { EventSubscription, EventSubscriptionInput } from '../../entities/events/event';
import { Observable, of, switchMap, take } from 'rxjs';
/**
 * The users service.
 */
@Injectable()
export class EventSubscriptionService {

  constructor(
    private apolloService: ApolloService
  ) {
  }

  /**
   * updates an event subscription
   * @param eventSubscription eventSubscription Input
   * @param callback method
   */
  public update(eventSubscription: EventSubscriptionInput, callback: (arg: any) => void): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_EVENT_SUBSCRIPTION_MUTATION,
      {
        input: eventSubscription,
      },
      callback
    );
  }
  /**
   * creates an event subscription
   * @param eventSubscriptionInput event subscription input
   * @param callback method
   */
  public create(eventSubscriptionInput: EventSubscriptionInput, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.CREATE_EVENT_SUBSCRIPTION_MUTATION,
      {
        input: eventSubscriptionInput,
      },
      callback
    );
  }

  public delete(eventSubscriptionId: string, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.DELETE_EVENT_SUBSCRIPTION_MUTATION,
      {
        id: eventSubscriptionId,
      },
      callback
    );
  }

  public sendTestEvent(callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.SEND_TEST_EVENT_MUTATION,
      {
        id: undefined,
        entityId: undefined,
        eventType: "testEvent.created",
        jsonData: undefined
      },
      callback
    );
  }

  public setSecret(id: string, secret: string, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_EVENT_SUBSCRIPTION_SECRET_MUTATION,
      {
        id: id,
        secret: secret
      },
      callback
    );
  }

  public deleteSecret(id: string, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.DELETE_EVENT_SUBSCRIPTION_SECRET_MUTATION,
      {
        id: id
      },
      callback
    );
  }

  /**
   * fetches a single event subscription by id
   * @param id event subscription id
   */
  public getEventSubscriptionById(id: string): Observable<EventSubscription> {
    return this.apolloService
      .query<fromGraphQl.EventSubscriptionByIdQueryResponse>(fromGraphQl.EVENT_SUBSCRIPTION_BY_ID_QUERY, { id })
      .pipe(
        take(1),
        switchMap((result) => {
          console.log('EventSubscriptionService.getEventSubscriptionById', result);
          return of(new EventSubscription(result?.data?.eventSubscription));
        })
      );
  }

}
